module.exports = __webpack_public_path__ + "fb21e6fd77f86d6ab406fa2bd0293df1.svg";